import {Component, Input, OnInit} from '@angular/core';
import {CalibrationData} from "../../calibration/calibrationStatus";
import {Subscription} from "rxjs";
import {UrlBuilder} from "../../url-builder/url.builder";
import {Scale} from "@progress/kendo-angular-gauges";
import {MeasurementData} from "../MeasurementDataList";


// ADQUEIN           is een 128 byte FILE welke de ingaande commando's
// voor de ad converter bevat, volgens:
// [kanaalnr.],[rekenwijze],[kanaalnr.],.....
// kanaalnr.: bevat kanaal byte
// rekenwijze:
//
//   Bit 7,6,5: Meetbereik (RANGE)
// Het meetbereik (bit 7-6-5) is als volgt gedefinieerd:
// 000x x00  -40 <> 369.2 gr.C
// 001x x20  -40 <> 164.6 gr.C
// 010x x40  -40 <> 62.3 gr.C
// 011x x60  Vrij
// 100x x80 - 0 - 1 Volt
// ng build

// 110x xC0 -  0 - 5 Volt
// 111x xE0 - 5 Volt + A-kanaal
//
// Bit 4:  Externe meting (COMBUS) bit. Was reserved.
//
//   Bit 3-0: rekenwijze. (METHOD)
// 0 = Reserve.
// 1 = -40 tot +62.3 gr.C gecorrigeerd
// 2 = -40 tot 164.6 gr.C gecorrigeerd
// 3 = -40 tot 369.2 gr.C gecorrigeerd
// 4 = 0 - 1023 counts
// 5 = 0 - 1423 counts (pH)
// 6 = -12 tot 1011 counts
// 7 = 0 tot 511 counts
// 8 = -500 tot 523 counts
// 9 = 0 tot 2047 counts
// 10 = Weerstandsmeting 0-100 kohm.

//



enum eCONVERSION_TYPE
{
  conversion5Volt,
  conversionR,
  conversion1Volt,
  conversion369GrC,
  conversion164GrC,
  conversion62GrC,
}



@Component({
  selector: 'app-meting-gauge',
  templateUrl: './measurement-gauge.component.html',
  styleUrls: ['./measurement-gauge.component.css']
})
export class MeasurementGaugeComponent implements OnInit {
  @Input()
  public measurementData: MeasurementData = new MeasurementData();
  public ticksColor = "#008000";
  public labelsColor = "#0000ff";
  private conversion: eCONVERSION_TYPE = eCONVERSION_TYPE.conversion5Volt;

  constructor() { }

  ngOnInit(): void {
  }

  GetUnit(): string {
    switch(this.conversion) {
      case eCONVERSION_TYPE.conversion369GrC: return "°C";
      case eCONVERSION_TYPE.conversion164GrC: return "°C";
      case eCONVERSION_TYPE.conversion62GrC: return "°C";
      case eCONVERSION_TYPE.conversion5Volt: return "Volt";
      case eCONVERSION_TYPE.conversion1Volt: return "Volt";
      case eCONVERSION_TYPE.conversionR: return "kΩ";
      default: return "unknown";
    }
  }


  SetConversionType(): void
  {
      switch (this.measurementData.tmsc_parameter & 0xF0) {
        case 0x00:    // b000   -40 <> 369.2 gr.C
          this.conversion = eCONVERSION_TYPE.conversion369GrC;
          break;

        case 0x20:    // b001x x20  -40 <> 164.6 gr.C
          this.conversion = eCONVERSION_TYPE.conversion164GrC;
          break;

        case 0x40:    // b010x x40  -40 <> 62.3 gr.C
          this.conversion = eCONVERSION_TYPE.conversion62GrC;
          break;

        case 0x60:    // b011x x60  Vrij
          this.conversion = eCONVERSION_TYPE.conversion1Volt;
          break;

        case 0x80:    // b100x x80 - 0 - 1 Volt
          this.conversion = eCONVERSION_TYPE.conversion1Volt;
          break;

        case 0xA0:    // b101x xA0 - 1 Volt + A-kanaal
          this.conversion = eCONVERSION_TYPE.conversion1Volt;
          break;

        case 0xC0:    // b110x xC0 -  0 - 5 Volt
          this.conversion = eCONVERSION_TYPE.conversion5Volt;
          break;

        case 0xE0:    // b111x xE0 - 5 Volt + A-kanaal
          this.conversion = eCONVERSION_TYPE.conversion5Volt;
          break;
      }
      switch (this.measurementData.tmsc_parameter & 0xF) {
         case 0:  // 0 = Reserve.
         case 1:  // 1 = -40 tot +62.3 gr.C gecorrigeerd
         case 2:  // 2 = -40 tot 164.6 gr.C gecorrigeerd
         case 3:  // 3 = -40 tot 369.2 gr.C gecorrigeerd
         case 4:  // 4 = 0 - 1023 counts
         case 5:  // 5 = 0 - 1423 counts (pH)
         case 6:  // 6 = -12 tot 1011 counts
         case 7:  // 7 = 0 tot 511 counts
         case 8:  // 8 = -500 tot 523 counts
         case 9:  // 9 = 0 tot 2047 counts
          break;
        case 10: // 10 = Weerstandsmeting 0-100 kohm.(niet linear)
          this.conversion = eCONVERSION_TYPE.conversionR;
          break;
      }
  }

  GetVolts(): number {
    switch(this.conversion) {
      case eCONVERSION_TYPE.conversion1Volt: return 1;
      case eCONVERSION_TYPE.conversion5Volt: return 5;
      default:                               return -100;
    }

  }


  GetValue(): number {
    this.SetConversionType();

    // Temperature measurement
    if((this.measurementData.tmsc_parameter & 0x80) == 0x00) {
      if( this.measurementData.rawvalue & 0x8000)
        return (this.measurementData.rawvalue-65536) / 10;
      else
        return this.measurementData.rawvalue / 10;
    }
    // Volts or resistor
    switch(this.measurementData.tmsc_parameter & 0xF) {
      case 0:
      case 1:
      case 2:
      case 3:
        return NaN;
      case 4:
        return (this.GetVolts() * this.measurementData.rawvalue) / 1023;
      case 5:
        return (this.GetVolts() * this.measurementData.rawvalue) / 1423;
      case 6:
        return (this.GetVolts() * (this.measurementData.rawvalue + 12)) / 1023;
      case 7:
        return (this.GetVolts() * (this.measurementData.rawvalue + 12)) / 511;
      case 8:
        return (this.GetVolts() * (this.measurementData.rawvalue + 500)) / 1023;
      case 9:
        return (this.GetVolts() * this.measurementData.rawvalue) / 2047;
      case 10:  // 4096 == 100.000 Ohm
        return (100 * this.measurementData.rawvalue) / 4096;
      case 11:
      case 12:
      case 13:
      case 14:
      case 15:
      case 16:
      default:
        return NaN;
    }
    }


    GetValueStr(): string {
      switch(this.conversion) {
        case eCONVERSION_TYPE.conversion369GrC:   return this.GetValue().toFixed(1);
        case eCONVERSION_TYPE.conversion164GrC:   return this.GetValue().toFixed(1);
        case eCONVERSION_TYPE.conversion62GrC:    return this.GetValue().toFixed(1);
        case eCONVERSION_TYPE.conversion1Volt:    return this.GetValue().toFixed(2);
        case eCONVERSION_TYPE.conversion5Volt:    return this.GetValue().toFixed(2);
        case eCONVERSION_TYPE.conversionR:        return this.GetValue().toFixed(2);
        default:                                  return this.GetValue().toFixed(2);
      }
    }


  GetScale(): Scale {
    let conversion369GrC: Scale = new class implements Scale {
      max = 369;   // The service calibrates at -20 and +50
      min = -40;
    };
    let conversion164GrC: Scale = new class implements Scale {
      max = 164;   // The service calibrates at -20 and +50
      min = -40;
    };
    let conversion62GrC: Scale = new class implements Scale {
      max = 62;   // The service calibrates at -20 and +50
      min = -40;
    };
    let scale5Volt: Scale = new class implements Scale {
      max = 5;
      min = 0;
    };
    let scale1Volt: Scale = new class implements Scale {
      max = 1;
      min = 0;
    };
    let scaleResistor: Scale = new class implements Scale {
      max = 100;
      min = 0;
    };
    switch (this.conversion)
    {
      case eCONVERSION_TYPE.conversion369GrC:   return conversion369GrC;
      case eCONVERSION_TYPE.conversion164GrC:   return conversion164GrC;
      case eCONVERSION_TYPE.conversion62GrC:   return conversion62GrC;
      case eCONVERSION_TYPE.conversion5Volt: return scale5Volt;
      case eCONVERSION_TYPE.conversion1Volt: return scale1Volt;
      case eCONVERSION_TYPE.conversionR:     return scaleResistor;
      default: return scale5Volt;
    }
  }



}
